import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilService } from '../../../../shared/util.service';
import { Subscription } from 'rxjs';
import { Hotel } from 'app/shared/model';
import { DateService } from 'app/shared/services/date.service';

@Component({
    selector: 'mh-section-followup-properties',
    templateUrl: './section-followup-properties.component.html',
    standalone: false
})
export class SectionFollowupPropertiesComponent implements OnInit, OnDestroy {
  @Input()
  productId = 1;
  waiting = true;
  util: UtilService;
  report: string;

  chainFilter: Hotel[] = [];
  originalChainFilter: Hotel[] = [];
  chainToReport: Hotel[] = [];
  isReady = false;
  surveysReady = false;

  fidelityPermisions: string[] = [];
  headerTable: string[] = [];
  subscription = new Subscription();

  constructor(private utilService: UtilService, private dateService: DateService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.util = this.utilService;
    this.subscription = this.utilService.isCustomerChanged().subscribe(() => {
      this.initSummary();
    });
    this.utilService.currentProductId = this.productId;
    this.fidelityPermisions = this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_followup');
    this.report = this.productId === 1 ? 'chainFollowupSummary' : 'chainOnsiteFollowupSummary';
    this.initSummary();
    this.headerTable = this.getHeaderTable();
    this.isReady = true;
  }

  getHeaderTable() {
    const guestSuffix = (this.isRetail && '_retail') || (this.isClinic && '_clinic') || '';
    const headers = [
      'customer',
      'nps',
      'tripAdvisorRanking',
      'pms',
      'mh_rate_response',
      'email_surveys',
      'open_surveys',
      'answers_quantity',
      'guests_quantity' + guestSuffix,
      'valid_guests_quantity' + guestSuffix,
      'total_mentions',
      'semantic_index',
    ];
    return this.isRetail || this.isClinic ? headers.filter((x) => x !== 'tripAdvisorRanking') : headers;
  }

  initSummary() {
    this.headerTable = this.getHeaderTable();
    this.waiting = false;
  }

  setChain(chain: Hotel[]) {
    setTimeout(() => {
      this.originalChainFilter = [...chain];
      this.chainFilter = [...chain];
      this.cd.detectChanges();
    }, 0);
  }

  setHotelsFilter(hotels: Hotel[]) {
    this.chainFilter = [...hotels];
  }

  onSurveysLoaded() {
    this.surveysReady = true;
  }

  setChainToReport($event) {
    this.chainToReport = $event;
  }

  dataIsReady(state: boolean) {
    setTimeout(() => {
      this.isReady = state;
    }, 200);
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get startDate() {
    return this.currentDates.startDate;
  }

  get endDate() {
    return this.currentDates.endDate;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }

  get isRetail() {
    return this.utilService.customerIsRetail;
  }

  get isClinic() {
    return this.utilService.customerIsClinic;
  }

  get reportSlug() {
    return this.productId === 1 ? 'corporative_followup_properties_report' : 'corporative_onsite_properties_report';
  }
}
